import React, { Component } from 'react'
import { Link } from 'gatsby'
import { Container, Row, Col, Button } from 'reactstrap'
import Slider from "react-slick"

import HomeTile from './HomeTile'

const tilesWidth = () => {
	if (typeof window !== 'undefined') {
		switch (true) {
			case window.innerWidth < 768:
				return { nbrSlide: 2 }
			case window.innerWidth < 1440:
				return { nbrSlide: 4 }
			default:
				return { nbrSlide: 4 }
		}
	}
	return { nbrSlide: 4, tileWidth: 241 }
}

class HomeTiles extends Component {
	constructor(props, context) {
		super(props, context)
		this.state = {
			...tilesWidth(),
			currentSlideIndex: 0
		}
	}

	componentDidMount() {
		typeof window !== 'undefined' && window.addEventListener('resize', this.tilesUpdateWindowsWidth)
		// Mettre à jour l'accessibilité après le montage initial
		this.updateSlideAccessibility()
	}

	componentDidUpdate() {
		// Mettre à jour l'accessibilité après chaque mise à jour
		this.updateSlideAccessibility()
	}

	componentWillUnmount() {
		typeof window !== 'undefined' && window.removeEventListener('resize', this.tilesUpdateWindowsWidth)
	}

	tilesUpdateWindowsWidth = () => {
		this.setState(tilesWidth())
	}

	updateSlideAccessibility = () => {
		// Attendre que le DOM soit mis à jour
		setTimeout(() => {
			if (typeof window === 'undefined') return

			// Trouver le conteneur du slider dans le DOM
			// react-slick crée une structure avec .slick-list contenant .slick-track contenant .slick-slide
			// Chercher d'abord via l'API du slider, puis via le DOM
			let sliderContainer = null
			if (this.slider) {
				sliderContainer = this.slider.innerSlider?.list ||
					(this.slider.innerSlider?.listRef?.current)
			}

			// Si on n'a pas trouvé via l'API, chercher dans le DOM
			if (!sliderContainer) {
				sliderContainer = document.querySelector('.hometiles .slick-list')
			}

			if (!sliderContainer) return

			// Trouver tous les slides dans le slider
			const slides = sliderContainer.querySelectorAll('.slick-slide') || []

			slides.forEach((slide) => {
				// Ne pas utiliser aria-hidden : garder tout le contenu dans l'arbre d'accessibilité
				// pour que les lecteurs d'écran puissent annoncer tous les tuiles.
				slide.removeAttribute('aria-hidden')
				// Pour le clavier : empêcher le focus sur les slides hors écran (slick-active = visible)
				const isHidden = !slide.classList.contains('slick-active')
				// Trouver tous les éléments focalisables dans le slide
				const focusableElements = slide.querySelectorAll(
					'a, button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])'
				)

				focusableElements.forEach((element) => {
					if (isHidden) {
						// Si le slide est caché, retirer le focus du clavier
						// Stocker l'état original si ce n'est pas déjà fait
						if (!element.hasAttribute('data-original-tabindex')) {
							const originalTabindex = element.getAttribute('tabindex')
							if (originalTabindex !== null) {
								element.setAttribute('data-original-tabindex', originalTabindex)
							} else {
								element.setAttribute('data-original-tabindex', '')
							}
						}
						element.setAttribute('tabindex', '-1')
					} else {
						// Si le slide est visible, restaurer le focus si nécessaire
						const originalTabindex = element.getAttribute('data-original-tabindex')
						if (originalTabindex !== null) {
							if (originalTabindex === '') {
								// L'élément n'avait pas de tabindex, le retirer pour utiliser le comportement par défaut
								element.removeAttribute('tabindex')
							} else {
								// Restaurer le tabindex original
								element.setAttribute('tabindex', originalTabindex)
							}
							element.removeAttribute('data-original-tabindex')
						}
					}
				})
			})
		}, 100)
	}

	render() {
		// Gestion des props manquantes avec valeurs par défaut
		const safeProps = {
			attrs: this.props.attrs || {},
			images: Array.isArray(this.props.images) ? this.props.images : []
		}

		// Vérification que attrs.items est un tableau
		const safeItems = Array.isArray(safeProps.attrs?.items) ? safeProps.attrs.items : []

		const settings = {
			dots: false,
			infinite: false,
			slidesToScroll: this.state.nbrSlide,
			slidesToShow: this.state.nbrSlide,
			variableWidth: true
		}

		return (
			<div className="home-services-section bg-light py-5">
				<Container>
					<Row>
						<Col sm="12" lg="6">
							<h1 className="section-title"><span>Les services</span> et infos pratiques</h1>
						</Col>
						<Col sm="12" lg="6">
							<p className="section-link text-lg-right mt-1 mt-lg-4">
								<Link className="tiles-home-all-link" to="/services-infos-pratiques/">
									Voir tous les services et infos pratiques
								</Link>
							</p>
						</Col>
					</Row>
					<div className="hometiles slideshow-wrapper">
						<div className={`slideshow${safeItems.length > 0 ? '' : ' placeholder'}`} role="region" aria-label="Carrousel des services et infos pratiques">
							<div className="visually-hidden" aria-live="polite" aria-atomic="true">
								{`Slide ${this.state.currentSlideIndex + 1} sur ${safeItems.length > 0 ? safeItems.length : 6}`}
							</div>
							<Button
								className="custom-slick-prev"
								onClick={() => {
									if (this.slider) {
										this.slider.slickGoTo(0)
										this.updateSlideAccessibility()
									}
								}}
								aria-label="Aller au début de la galerie"
							/>
							<Slider
								ref={slider => {
									this.slider = slider
									// Mettre à jour l'accessibilité après le rendu initial
									if (slider) {
										setTimeout(() => this.updateSlideAccessibility(), 100)
									}
								}}
								{...settings}
								afterChange={(index) => {
									this.setState({ currentSlideIndex: index })
									this.updateSlideAccessibility()
								}}
							>
								{safeItems.length > 0 ? (
									safeItems.map((i, index) => (
										<HomeTile key={index} images={safeProps.images} {...i} />
									))
								) : (
									Array.from(Array(6)).map((i, index) => (
										<HomeTile key={index} placeholder />
									))
								)}
							</Slider>
						</div>
					</div>
				</Container>
			</div>
		)
	}
}

export default HomeTiles
